import moment from 'moment';
import React from 'react';
import ExternalMeetingLinkButton from '../../../../elements/Button/ExternalMeetingLinkButton';
import styles from './VirtualRoomMeetingButton.module.scss';
import { isMeetingConfirmed } from 'common-data-handling';
import { useScheduledUpdate } from '../../../../../misc/hooks';

function VirtualRoomMeetingButton(props) {
    const { className = '', event, meeting } = props;

    if (!meeting.virtualroom_url) return null;
    if (!isMeetingConfirmed(meeting)) return null;

    const timeDifference = moment(meeting.start_utc).diff(moment(), 'minutes'),
        disable = timeDifference - 10 > 0;

    useScheduledUpdate(meeting.start_local, 1000);

    return <ExternalMeetingLinkButton disabled={disable} className={[className, styles.VirtualRoomMeetingButton].join(' ')} {...meeting} meetingId={meeting.id} eventId={event.id} />;
}

export default VirtualRoomMeetingButton;
